// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Hind_0f85a8', '__Hind_Fallback_0f85a8'","fontStyle":"normal"},"className":"__className_0f85a8","variable":"__variable_0f85a8"};